/** Guías externas de instalación (sitio mantenido aparte del equipo de producto). */
export const HUBSPOT_INSTALL_GUIDE_URL =
  'https://main.d2vpew3jmnvl49.amplifyapp.com/#/guia/instalacion-chat';
